import {Component, computed, inject, input} from '@angular/core';
import {FormControl} from '@angular/forms';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {Dropdown} from '../../../../components/dropdown/dropdown';
import {MultiDropdown} from '../../../../components/multi-dropdown/multi-dropdown';
import {ProductType} from '../../../../../api';

interface ProductTypeOption {
  id: string;
  name: string;
}

@Component({
  selector: 'elcia-product-type-dropdown',
  imports: [Dropdown, MultiDropdown, TranslatePipe],
  templateUrl: './product-type-dropdown.html',
})
export class ProductTypeDropdown {
  private readonly translate = inject(TranslateService);
  private readonly langChange = toSignal(this.translate.onLangChange, {initialValue: null});

  control = input.required<FormControl>();
  isMulti = input.required<boolean>();

  protected readonly options = computed<ProductTypeOption[]>(() => {
    this.langChange();
    return Object.values(ProductType).map(type => ({
      id: type,
      name: this.translate.instant(`product-type.${type}`),
    }));
  });
}
